export function CTA() {
	return (
		<section style={styles.section}>
			<div style={styles.inner}>
				<div style={styles.deco}>☽</div>
				<h2 style={styles.h2}>
					Wujudkan Lembaga Keislaman yang Aktif, Mandiri &amp; Produktif
				</h2>
				<p style={styles.desc}>
					Bergabung dengan program pemberdayaan MASQUDE — untuk Masjid, Yayasan,
					Pesantren, LAZ/ZISWAF, dan Komunitas Dakwah Indonesia
				</p>
				<div style={styles.btns}>
					<a
						href="https://wa.me/62895361117333"
						target="_blank"
						rel="noreferrer"
						style={styles.btnDark}
						onMouseEnter={(e) => {
							e.currentTarget.style.background = "var(--kuning)";
							e.currentTarget.style.color = "var(--coklat)";
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.background = "#1A0A00";
							e.currentTarget.style.color = "var(--kuning2)";
						}}>
						💬 WhatsApp Sekarang
					</a>
					<a
						href="https://www.nusaqu.id"
						target="_blank"
						rel="noreferrer"
						style={styles.btnWhite}
						onMouseEnter={(e) => {
							e.currentTarget.style.background = "rgba(255,255,255,.15)";
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.background = "rgba(255,255,255,.1)";
						}}>
						🌐 Kunjungi nusaqu.id
					</a>
				</div>
			</div>
		</section>
	);
}

export function Footer() {
	return (
		<footer style={styles.footer}>
			<img src="/masq.png" alt="MASQUDE" style={styles.logo} />
			<div style={styles.brand}>
				MASQUDE
				<small style={styles.brandSub}>
					by PT Nusa Sentosa Indonesia — nusaqu.id
				</small>
			</div>
			<p style={styles.copy}>
				© 2025 NusaQu Indonesia · Program Pemberdayaan Lembaga Keislaman
			</p>
		</footer>
	);
}

const styles = {
	section: {
		background:
			"linear-gradient(135deg, var(--coklat2) 0%, var(--coklat) 100%)",
		padding: "5rem 5%",
		textAlign: "center",
		position: "relative",
		overflow: "hidden",
	},
	inner: {
		position: "relative",
		zIndex: 2,
		maxWidth: "700px",
		margin: "0 auto",
	},
	deco: {
		position: "absolute",
		top: "-5%",
		left: "50%",
		transform: "translateX(-50%)",
		fontSize: "20rem",
		color: "rgba(255,255,255,.04)",
		pointerEvents: "none",
		lineHeight: 1,
	},
	h2: {
		fontFamily: "Lora, serif",
		fontSize: "clamp(1.8rem, 3.5vw, 3rem)",
		fontWeight: 700,
		color: "white",
		marginBottom: "1rem",
	},
	desc: {
		color: "rgba(255,255,255,.7)",
		fontSize: "1rem",
		lineHeight: 1.8,
		marginBottom: "2rem",
	},
	btns: {
		display: "flex",
		gap: "1rem",
		justifyContent: "center",
		flexWrap: "wrap",
	},
	btnDark: {
		background: "#1A0A00",
		color: "var(--kuning2)",
		padding: "0.9rem 2.2rem",
		borderRadius: "10px",
		fontSize: "1rem",
		fontWeight: 700,
		textDecoration: "none",
		transition: "all 0.25s",
	},
	btnWhite: {
		background: "rgba(255,255,255,.1)",
		color: "white",
		border: "2px solid rgba(255,255,255,.3)",
		padding: "0.9rem 2.2rem",
		borderRadius: "10px",
		fontSize: "1rem",
		fontWeight: 700,
		textDecoration: "none",
		transition: "all 0.25s",
	},
	footer: {
		background: "#1A0A00",
		padding: "2.5rem 5%",
		textAlign: "center",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: "0.5rem",
	},
	logo: { height: "36px", marginBottom: "0.3rem", opacity: 0.9 },
	brand: {
		fontFamily: "Lora, serif",
		fontSize: "1.4rem",
		fontWeight: 700,
		color: "var(--kuning2)",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	brandSub: {
		display: "block",
		fontSize: "0.78rem",
		color: "rgba(255,255,255,.4)",
		fontFamily: "Plus Jakarta Sans, sans-serif",
		fontWeight: 400,
		marginTop: "0.2rem",
	},
	copy: {
		fontSize: "0.82rem",
		color: "rgba(255,255,255,.3)",
		marginTop: "0.5rem",
	},
};
